import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

export const Search = (props) => {
  return <FontAwesomeIcon faIcon={faSearch} {...props} />
}
